import Backbone from 'backbone';
import Marionette from 'backbone.marionette';
import NavigationTemplate from '../templates/partials/NavigationTemplate.hbs';
import Util from '../util/Util';
import ProsEvents from '../util/ProsEvents';
import ProsEventHandler from '../events/ProsEventHandler';

const NavigationView = Marionette.ItemView.extend({

  template: NavigationTemplate,

  ui: {
    startOverBtn: '.start-over',
    prevPageBtn: '.prev-page',
    nextPageBtn: '.next-page',
  },

  events: {
    'click @ui.startOverBtn': 'moveToFirstPage',
    'click @ui.prevPageBtn': 'triggerPrevEvent',
    'click @ui.nextPageBtn': 'triggerNextEvent',
  },

  initialize(options) {
    Object.assign(this, options);
    const { buttonColor, chevronBtnSize, rewindBtnSize } = this;
    this.model = new Backbone.Model({ buttonColor, chevronBtnSize, rewindBtnSize });
    this.calculatePageInfo(this.pageInfo, { silent: true });
    this.listenTo(this.model, 'change', this.render.bind(this));

    this.listenTo(this.prosPanel, ProsEvents.PAGE_INFORMATION, (pageInformation) => {
      this.update(pageInformation);
    });
  },

  calculatePageInfo(pageInfo) {
    const { currentPage, childPerPage } = pageInfo;
    const collectionSize = this.prosPanel.getCollectionSize();

    const maxPage = Math.ceil(collectionSize / childPerPage);
    this.currentPage = currentPage;
    this.maxPage = maxPage;
    this.model.set({ currentPage, maxPage }, { silent: true });
    this.updateBtnStatus();
  },

  update(pageInfo) {
    this.calculatePageInfo(pageInfo);
    this.model.trigger('change');
  },

  moveToFirstPage() {
    if (!this.firstPage()) {
      this.prosPanel.moveToFirstPage();
      ProsEventHandler.triggerPageNavAnalytics();
    }
  },

  triggerPrevEvent() {
    if (!this.firstPage()) {
      this.prosPanel.triggerPrevEvent();
      ProsEventHandler.triggerPageNavAnalytics();
    }
  },

  triggerNextEvent() {
    if (!this.lastPage()) {
      this.prosPanel.triggerNextEvent();
      ProsEventHandler.triggerPageNavAnalytics();
    }
  },

  lastPage() {
    return this.currentPage === this.maxPage;
  },

  firstPage() {
    return this.currentPage === 1;
  },

  justOnePage() {
    return this.maxPage === 1;
  },

  updateBtnStatus() {
    let startOverBtnStatus = 'disabled';
    let prevPageBtnStatus = 'disabled';
    let nextPageBtnStatus = 'disabled';
    if (this.firstPage()) {
      if (!this.justOnePage()) {
        nextPageBtnStatus = 'enabled';
      }
    } else if (this.lastPage()) {
      startOverBtnStatus = 'enabled';
      prevPageBtnStatus = 'enabled';
    } else {
      startOverBtnStatus = 'enabled';
      prevPageBtnStatus = 'enabled';
      nextPageBtnStatus = 'enabled';
    }
    this.model.set({ startOverBtnStatus, prevPageBtnStatus, nextPageBtnStatus }, { silent: true });
  },

}, {

  init(options) {
    const { prosPanel } = options;
    const { orientation, viewType } = options.prosPanel.config;
    if (!(viewType === 'carousel' && orientation === 'horizontal')) {
      return false;
    }

    const buttonColor = 'gr';
    let chevronBtnSize = 'large';
    let rewindBtnSize = 'large';
    prosPanel.$el.addClass('pros-page-navigation');
    if (Util.isMobile()) {
      // prosPanel.$el.append('<div class="page-navigation footer"  aria-live="polite">');
      chevronBtnSize = 'full';
      rewindBtnSize = 'full';
    } else {
      // prosPanel.$el.find('.shopAll').addClass('page-navigation header');
    }
    const navigationView = new NavigationView(Object.assign(
      {
        el: prosPanel.$el.find('.page-navigation'),
        buttonColor,
        chevronBtnSize,
        rewindBtnSize,
      },
      options,
    ));
    navigationView.render();
    return navigationView;
  },

});


export default NavigationView;
